const getters = {
  device: state => state.app.device,
  token: state => state.user.token
}
export default getters
